import { useId, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BuiltFormSection } from "../services/formLayoutBuilder";
import { FieldRuntimeProps } from "../types/record-producer-types";
import { RecordFormSection, resolveSectionTitle } from "./RecordFormSection";

export function RecordFormSectionTabs({ sections, runtimeStates, tableLabel, embedded = false }: {
    sections: BuiltFormSection[];
    runtimeStates: Record<string, FieldRuntimeProps>;
    tableLabel?: string;
    embedded?: boolean;
}) {
    const { t } = useTranslation();
    const instanceId = useId();
    const [activeId, setActiveId] = useState(sections[0]?.id);
    if (!sections.length) return null;
    const selectedId = sections.some(section => section.id === activeId) ? activeId : sections[0].id;

    return <Box>
        <Tabs
            value={selectedId}
            onChange={(_, value: string) => setActiveId(value)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ borderBottom: 1, borderColor: "divider" }}
        >
            {sections.map((section, index) => <Tab
                key={section.id}
                id={`${instanceId}-tab-${index}`}
                aria-controls={`${instanceId}-panel-${index}`}
                value={section.id}
                label={resolveSectionTitle(t, section.label, tableLabel) ?? String(index + 1)}
            />)}
        </Tabs>
        {sections.map((section, index) => <Box
            key={section.id}
            role="tabpanel"
            id={`${instanceId}-panel-${index}`}
            aria-labelledby={`${instanceId}-tab-${index}`}
            hidden={section.id !== selectedId}
            sx={{ pt: { xs: 1.5, sm: 2 } }}
        >
            <RecordFormSection section={section} runtimeStates={runtimeStates} hideTitle tableLabel={tableLabel} embedded={embedded} />
        </Box>)}
    </Box>;
}
